// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.splide {
  margin: 2rem auto;
  max-width: 100%;
  position: relative;
}
.splide .splide__track {
  overflow: hidden;
  border-radius: 0.5rem;
}
.splide .splide__slide {
  padding: 1rem;
  outline: none;
}
.splide .splide__slide img {
  width: 100%;
  border-radius: 0.375rem;
  object-fit: cover;
}
.splide .splide__pagination {
  bottom: -2rem;
}
.splide .splide__pagination li {
  margin: 0 0.25rem;
}
.splide .splide__pagination li button {
  background-color: var(--grays-500);
  width: 0.75rem;
  height: 0.75rem;
  border-radius: 50%;
  transition: background-color 0.3s ease;
}
.splide .splide__pagination li button:hover, .splide .splide__pagination li button:focus {
  background-color: var(--grays-700);
}
.splide .splide__pagination li button.is-active {
  background-color: var(--shades-100);
}
.splide .splide__arrow {
  background-color: var(--shades-100);
  color: var(--shades-0);
  padding: 0.5rem;
  border-radius: 999px;
  transition: background-color 0.3s ease;
}
.splide .splide__arrow:hover {
  background-color: var(--grays-900);
}
.splide .splide__arrow svg {
  fill: currentColor;
  width: 1rem;
  height: 1rem;
}

.wrp--toggle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.wrp--toggle .splide__toggle {
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  /* Show play icon by default */
}
.wrp--toggle .splide__toggle:focus {
  outline: 2px solid var(--primary-color500); /* Use a contrasting color for focus */
  outline-offset: 4px; /* Add space between outline and button */
}
.wrp--toggle .splide__toggle .splide__toggle__play {
  opacity: 1;
}
.wrp--toggle .splide__toggle.is-paused .splide__toggle__play {
  opacity: 1; /* Play icon visible when paused */
}
.wrp--toggle .splide__toggle.is-paused .splide__toggle__pause {
  opacity: 0; /* Hide the pause icon when paused */
}
.wrp--toggle .splide__toggle.is-playing .splide__toggle__play {
  opacity: 0;
}
.wrp--toggle .splide__toggle.is-playing .splide__toggle__pause {
  opacity: 1;
}
.wrp--toggle .splide__toggle__play,
.wrp--toggle .splide__toggle__pause {
  width: 36px;
  height: 66px;
  fill: var(--primary-color500);
  transition: opacity 0.3s ease, transform 0.2s ease;
}
.wrp--toggle .splide__toggle:active .splide__toggle__play,
.wrp--toggle .splide__toggle:active .splide__toggle__pause {
  transform: scale(0.95);
}

.splide__pagination {
  position: relative;
  margin: 1rem 0;
}

.splide .splide__pagination {
  bottom: 0;
}
.splide .splide__pagination li button {
  background-color: var(--grays-500);
}
.splide .splide__pagination li .is-active {
  background-color: var(--primary-color500);
}

.splide__pagination__page {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./assets/sass/_styles.scss","webpack://./src/index.scss","webpack://./assets/sass/_toggle.scss","webpack://./assets/sass/_pagination.scss"],"names":[],"mappings":"AAEA;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;ACDF;ADGE;EACE,gBAAA;EACA,qBAAA;ACDJ;ADIE;EACE,aAAA;EACA,aAAA;ACFJ;ADII;EACE,WAAA;EACA,uBAAA;EACA,iBAAA;ACFN;ADME;EACE,aAAA;ACJJ;ADMI;EACE,iBAAA;ACJN;ADMM;EACE,kCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sCAAA;ACJR;ADMQ;EAEE,kCAAA;ACLV;ADQQ;EACE,mCAAA;ACNV;ADYE;EACE,mCAAA;EACA,sBAAA;EACA,eAAA;EACA,oBAAA;EACA,sCAAA;ACVJ;ADYI;EACE,kCAAA;ACVN;ADaI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;ACXN;;ACnDA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ADsDF;ACpDE;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EAOA,8BAAA;ADgDJ;ACrDI;EACE,0CAAA,EAAA,sCAAA;EACA,mBAAA,EAAA,yCAAA;ADuDN;ACnDI;EACE,UAAA;ADqDN;AClDI;EACE,UAAA,EAAA,kCAAA;ADoDN;ACjDI;EACE,UAAA,EAAA,oCAAA;ADmDN;AChDI;EACE,UAAA;ADkDN;AC/CI;EACE,UAAA;ADiDN;AC7CE;;EAEE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kDAAA;AD+CJ;AC5CE;;EAEE,sBAAA;AD8CJ;;AEjGA;EACE,kBAAA;EACA,cAAA;AFoGF;;AEjGE;EACE,SAAA;AFoGJ;AElGM;EACE,kCAAA;AFoGR;AElGM;EACE,yCAAA;AFoGR;;AE/FA;EACE,UAAA;AFkGF","sourcesContent":["// Accessible Custom Slider Styles\n\n.splide {\n  margin: 2rem auto;\n  max-width: 100%;\n  position: relative;\n\n  .splide__track {\n    overflow: hidden;\n    border-radius: 0.5rem;\n  }\n\n  .splide__slide {\n    padding: 1rem;\n    outline: none;\n\n    img {\n      width: 100%;\n      border-radius: 0.375rem;\n      object-fit: cover;\n    }\n  }\n\n  .splide__pagination {\n    bottom: -2rem;\n\n    li {\n      margin: 0 0.25rem;\n\n      button {\n        background-color: var(--grays-500);\n        width: 0.75rem;\n        height: 0.75rem;\n        border-radius: 50%;\n        transition: background-color 0.3s ease;\n\n        &:hover,\n        &:focus {\n          background-color: var(--grays-700);\n        }\n\n        &.is-active {\n          background-color: var(--shades-100);\n        }\n      }\n    }\n  }\n\n  .splide__arrow {\n    background-color: var(--shades-100);\n    color: var(--shades-0);\n    padding: 0.5rem;\n    border-radius: 999px;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background-color: var(--grays-900);\n    }\n\n    svg {\n      fill: currentColor;\n      width: 1rem;\n      height: 1rem;\n    }\n  }\n}\n",".splide {\n  margin: 2rem auto;\n  max-width: 100%;\n  position: relative;\n}\n.splide .splide__track {\n  overflow: hidden;\n  border-radius: 0.5rem;\n}\n.splide .splide__slide {\n  padding: 1rem;\n  outline: none;\n}\n.splide .splide__slide img {\n  width: 100%;\n  border-radius: 0.375rem;\n  object-fit: cover;\n}\n.splide .splide__pagination {\n  bottom: -2rem;\n}\n.splide .splide__pagination li {\n  margin: 0 0.25rem;\n}\n.splide .splide__pagination li button {\n  background-color: var(--grays-500);\n  width: 0.75rem;\n  height: 0.75rem;\n  border-radius: 50%;\n  transition: background-color 0.3s ease;\n}\n.splide .splide__pagination li button:hover, .splide .splide__pagination li button:focus {\n  background-color: var(--grays-700);\n}\n.splide .splide__pagination li button.is-active {\n  background-color: var(--shades-100);\n}\n.splide .splide__arrow {\n  background-color: var(--shades-100);\n  color: var(--shades-0);\n  padding: 0.5rem;\n  border-radius: 999px;\n  transition: background-color 0.3s ease;\n}\n.splide .splide__arrow:hover {\n  background-color: var(--grays-900);\n}\n.splide .splide__arrow svg {\n  fill: currentColor;\n  width: 1rem;\n  height: 1rem;\n}\n\n.wrp--toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.wrp--toggle .splide__toggle {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 48px;\n  /* Show play icon by default */\n}\n.wrp--toggle .splide__toggle:focus {\n  outline: 2px solid var(--primary-color500); /* Use a contrasting color for focus */\n  outline-offset: 4px; /* Add space between outline and button */\n}\n.wrp--toggle .splide__toggle .splide__toggle__play {\n  opacity: 1;\n}\n.wrp--toggle .splide__toggle.is-paused .splide__toggle__play {\n  opacity: 1; /* Play icon visible when paused */\n}\n.wrp--toggle .splide__toggle.is-paused .splide__toggle__pause {\n  opacity: 0; /* Hide the pause icon when paused */\n}\n.wrp--toggle .splide__toggle.is-playing .splide__toggle__play {\n  opacity: 0;\n}\n.wrp--toggle .splide__toggle.is-playing .splide__toggle__pause {\n  opacity: 1;\n}\n.wrp--toggle .splide__toggle__play,\n.wrp--toggle .splide__toggle__pause {\n  width: 36px;\n  height: 66px;\n  fill: var(--primary-color500);\n  transition: opacity 0.3s ease, transform 0.2s ease;\n}\n.wrp--toggle .splide__toggle:active .splide__toggle__play,\n.wrp--toggle .splide__toggle:active .splide__toggle__pause {\n  transform: scale(0.95);\n}\n\n.splide__pagination {\n  position: relative;\n  margin: 1rem 0;\n}\n\n.splide .splide__pagination {\n  bottom: 0;\n}\n.splide .splide__pagination li button {\n  background-color: var(--grays-500);\n}\n.splide .splide__pagination li .is-active {\n  background-color: var(--primary-color500);\n}\n\n.splide__pagination__page {\n  opacity: 1;\n}",".wrp--toggle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .splide__toggle {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 48px;\n\n    &:focus {\n      outline: 2px solid var(--primary-color500); /* Use a contrasting color for focus */\n      outline-offset: 4px; /* Add space between outline and button */\n    }\n\n    /* Show play icon by default */\n    .splide__toggle__play {\n      opacity: 1;\n    }\n\n    &.is-paused .splide__toggle__play {\n      opacity: 1; /* Play icon visible when paused */\n    }\n\n    &.is-paused .splide__toggle__pause {\n      opacity: 0; /* Hide the pause icon when paused */\n    }\n\n    &.is-playing .splide__toggle__play {\n      opacity: 0;\n    }\n\n    &.is-playing .splide__toggle__pause {\n      opacity: 1;\n    }\n  }\n\n  .splide__toggle__play,\n  .splide__toggle__pause {\n    width: 36px;\n    height: 66px;\n    fill: var(--primary-color500);\n    transition: opacity 0.3s ease, transform 0.2s ease;\n  }\n\n  .splide__toggle:active .splide__toggle__play,\n  .splide__toggle:active .splide__toggle__pause {\n    transform: scale(0.95);\n  }\n}\n",".splide__pagination {\n  position: relative;\n  margin: 1rem 0;\n}\n.splide {\n  .splide__pagination {\n    bottom: 0;\n    li {\n      button {\n        background-color: var(--grays-500);\n      }\n      .is-active {\n        background-color: var(--primary-color500);\n      }\n    }\n  }\n}\n.splide__pagination__page {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
